<template>
  <div class="cgm-core" :style="style" :class="{ isLongLanguage }">
    <div class="left-panel">
      <table border="0" cellspacing="0" cellpadding="4">
        <tr>
          <th>{{ $t('cgmInfo.indicator') }}</th>
          <th>{{ $t('cgmInfo.unit') }}</th>
          <th>{{ $t('cgmInfo.result') }}</th>
          <th>{{ $t('cgmInfo.reference') }}</th>
        </tr>
        <tr>
          <td>{{ $t('cgmInfo.cgmDays') }}</td>
          <td>{{ $t('unit.oneDay') }}</td>
          <td>
            <span>{{ (cgmRecord && cgmRecord.glucose) ? cgmRecord.glucose.length : '0' }}</span>
          </td>
          <td>&gt; 14</td>
        </tr>
        <tr>
          <td>{{ $t('cgmInfo.cgmActive') }}</td>
          <td>%</td>
          <td>
            <span>{{ cgmActive }}</span>
          </td>
          <td>&gt; 70</td>
        </tr>
        <tr>
          <td>{{ $t('cgmInfo.mbg') }}</td>
          <td>{{ $t('unit.mmolL') }}</td>
          <td>
            <span>{{ formatterIndicator(dataFirstPage(cgmRecord.mbg)) }}</span>
            <arrow :value="dataFirstPage(cgmRecord.mbg)" :lt="6.6" />
          </td>
          <td>&lt; {{ formatterConstantComma(6.6) }}</td>
        </tr>
        <tr>
          <td>{{ $t('cgmInfo.cv') }}</td>
          <td>%</td>
          <td>
            <span>{{ formatterIndicator(dataFirstPage(cgmRecord.cv)) }}</span>
            <arrow :value="dataFirstPage(cgmRecord.cv)" :lt="36.01" />
          </td>
          <td>&le; 36</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'
import arrow from '@/components/Arrow'

export default {
  name: 'CgmCoreParamTable',
  components: {
    arrow
  },
  mixins: [reDrawTrigger],
  props: {
    cgmRecord: {
      type: [Object],
      default: () => {
        return {
          eventMap: {},
          mage: [],
          num: [],
          mbg: [],
          maxbg: [],
          minbg: [],
          sdbg: [],
          pentagon: [],
          grade: {
            grade: 0
          },
          glucose: [],
          tir: {
            tir: []
          },
          lbgd28: [],
          lbgd39: [],
          lbgd100: [],
          lbgd139: [],
          lbgd222: []
        }
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    cgmActive() {
      /* eslint-disable-next-line */
      const { cgmRecord = {} } = this
      const totalNum = this.dataFirstPage(cgmRecord.num)
      const totalPerDayCount = cgmRecord.type ? 1440 : 288
      const rst = (totalNum && cgmRecord?.glucose?.length > 0) ? this.formatterIndicator((totalNum / (cgmRecord?.glucose?.length * totalPerDayCount) * 100)) : 0

      return rst
    },
    w() {      
      const { ds, isLongLanguage } = this
      
      if (isLongLanguage) {
        // return ds * (426 / 1740)
        // return ds * (436 / 1740)
        return ds * (500 / 1740)
      } else {
        return ds * (380 / 1740)
      }
    },
    style() {
      const { w, zoomRatio, high, ds, isLongLanguage } = this
      const rst = { width: w + 'px', zoom: zoomRatio }
      
      rst['marginRight'] = ds * (40 / 1740) + 'px'
      if (isLongLanguage) {
        rst['marginRight'] = ds * (20 / 1740) + 'px'
        rst['zoom'] = zoomRatio * 0.88
      }      
      
      return rst
    }
  },
  mounted() {},
  methods: {
    formatterConstantComma(value, fixedNum = 1) {
      value = +value
      return Number.isInteger(value) ? value : (this.isNeedConvertComma() ? value.toFixed(fixedNum).replace('.', ',') : value.toFixed(fixedNum))
    },
    isNeedConvertComma() {
      return ['cs'].includes(this.$i18n.locale)
    },
    formatterIndicator(value, isConvertUnitToMg) {
      if (isNaN(value)) {
        return ''
      }
      value = isConvertUnitToMg ? Number(value) * 18 : Number(value)
      if (isConvertUnitToMg) {
        return value.toFixed()
      }
      return Number.isInteger(value) ? value : (this.isNeedConvertComma() ? value.toFixed(2).replace('.', ',') : value.toFixed(2))
    },
    dataFirstPage(_data = []) {
      const data = _data || []
      if (data.length === 0) {
        return 0
      }
      return data[this.cgmRecord.glucose.length]
    }
  }
}
</script>
<style lang="scss" scoped>
.cgm-core {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: flex-start;
    height: 190px;
    margin-bottom: -50px;
    .left-panel {
        width: 100%;
        /* margin-top: 10px; */
        /* transform: scale(0.7); */
        transform-origin: 0 0;
        position: absolute;
        left: 0;
        table {
            width: 100%;
            height: 100%;
            margin-bottom: 10px;
            font-size: 14px;
            font-weight: 600;
            box-sizing: border-box;
            th {
                background-color: #4d913c;
                padding: 5px 0;
                color: white;
                font-size: 14px;
                border-right: 1px solid #d1d1d1;
                border-top: 1px solid #d1d1d1;
                box-sizing: border-box;
                &:first-child {
                    border-left: 1px solid #d1d1d1;
                }
            }
            td {
                box-sizing: border-box;
                border-right: 1px solid #d1d1d1;
                border-bottom: 1px solid #d1d1d1;
                padding: 6px 0;
                
                &:nth-child(3) {
                    text-align: left;
                    padding-left: 10px;
                    width: 60px;
                }
                
                &:first-child {
                    border-left: 1px solid #d1d1d1;
                    text-align: left;
                    padding-left: 10px;
                }
            }
            tr:last-child {
                td {
                    border-bottom: 1px solid #d1d1d1;
                }
            }
            .ghost {
                border-top: none;
                border-bottom: none;
                background-color: white;
            }
        }
    }
    .right-panel {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 26%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        transform: scale(0.8);
        transform-origin: 0 0;
        .tir-title {
            width: 100%;
            color: #426e06;
            font-size: 16px;
            font-weight: 500;
            text-align: center;
        }
        .tir-panel {
            width: 100%;
            height: 100%;
            position: relative;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            
            #tir {
                width: 60%;
                height: 100%;
            }
            .legend {
                height: 100%;
                position: absolute;
                right: 20px;
                .legend-item {
                    line-height: 30px;
                    max-width: 360px;
                    text-align: left;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    
                    &:nth-child(1) {
                        .icon {
                            background-color: #F59A24;
                        }
                    }
                    &:nth-child(2) {
                        .icon {
                            background-color: #FFFD01;
                        }
                    }
                    &:nth-child(3) {
              .icon {
                background-color: #0E9A33;
              }
            }
            &:nth-child(4) {
              .icon {
                background-color: #E56363;
              }
            }
            &:nth-child(5) {
              .icon {
                background-color: #CC5858;
              }
            }
          }
          .legend-item-long {
            line-height: 24px;
            white-space: pre-line;
          }
          .icon {
            width: 10px;
            height: 16px;
            margin-right: 10px;
          }
        }
      }
    }
  }
</style>
